
      $(document).on('click', 'html:not(.popup-opened) .popup-link', function() {
        $('html').addClass('popup-opened');
        $('.popup-scroll').scrollTop(0);
        $('.popup-scroll').each(function() {
          bodyScrollLock.disableBodyScroll($(this)[0]);
        })
      })
      $(document).on('click', 'html.popup-opened .popup-close', function() {
        bodyScrollLock.clearAllBodyScrollLocks();
        $('html').removeClass('popup-opened');
      })
    

      window.addEventListener("DOMContentLoaded", () => {
        // Find all nav columns across the banner
        const navCols = document.querySelectorAll(".home-banner-nav-col");
        navCols.forEach((col) => {
          col.addEventListener("click", function(e) {
            e.preventDefault();
            // Find which text heading or title is inside this clicked block to know which slide to go to
            const targetIndex = Number(this.dataset.slideIndex);
            // Locate the Webflow slider element on the page
            const slider = document.querySelector(".w-slider");
            if (slider) {
              // Find the left/right arrow buttons or slide nav dots inside this specific slider to trigger movement
              const slideNavDots = slider.querySelectorAll(".w-slider-dot");
              if (slideNavDots[targetIndex]) {
                slideNavDots[targetIndex].click();
              }
            }
          });
        });
      });
    

      window.addEventListener("DOMContentLoaded", () => {
        // Target the header element. 
        // In Webflow, combining the "section" and "header" classes creates ".section.header"
        const header = document.querySelector(".section.header") || document.querySelector(".header");
        if (header) {
          // Add a smooth fade transition
          header.style.transition = "background-color 0.4s ease";
          const updateHeaderColor = () => {
            if (window.scrollY > 20) {
              // Scrolled down: change to black
              header.style.backgroundColor = "#000000";
            } else {
              // At the top: change to transparent
              header.style.backgroundColor = "transparent";
            }
          };
          // Trigger when the user scrolls
          window.addEventListener("scroll", updateHeaderColor);
          // Run once on load to set the correct initial color
          updateHeaderColor();
        }
      });
    

      document.addEventListener("DOMContentLoaded", function() {
        // Get all the links inside the Webflow nav menu
        const navLinks = document.querySelectorAll('.w-nav-menu a');
        // Get the mobile menu button (hamburger)
        const menuButton = document.querySelector('.w-nav-button');
        // Loop through each link
        navLinks.forEach(function(link) {
          link.addEventListener('click', function() {
            // Check if the menu button is visible (meaning we are on mobile/tablet view)
            if (menuButton && window.getComputedStyle(menuButton).display !== 'none') {
              // Add a tiny delay to ensure Webflow registers the click properly
              setTimeout(function() {
                menuButton.click();
              }, 100); // 100 milliseconds delay
            }
          });
        });
      });
    

      document.addEventListener('click', function(event) {
        // List of standard Webflow background overlays and common custom ones
        const isBackdrop =
          event.target.classList.contains('w-commerce-commercecartbackdrop') ||
          event.target.classList.contains('w-dropdown-backdrop') ||
          event.target.classList.contains('w-nav-overlay');
        if (isBackdrop) {
          // 1. Remove inline overflow styles applied by your Interactions
          document.body.style.overflow = 'visible';
          document.documentElement.style.overflow = 'visible';
          // Clear the styles completely so stylesheets take over again
          document.body.style.overflow = '';
          document.documentElement.style.overflow = '';
          // 2. Remove Webflow's native body-pin class (used on some mobile menus)
          document.body.classList.remove('w-nav-body-pin');
        }
      });
    